__turbopack_context__.v({
  "BentoCardSizeCss": "_9NPYwq_BentoCardSizeCss",
  "BentoHeading": "_9NPYwq_BentoHeading",
  "BentoPara": "_9NPYwq_BentoPara",
});
